import $ from 'jquery' // jQuery

import scrollLock from './functions/_scrollLock.js' // スクロールロック

import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉

/* global  */ // tUrl等のグローバル変数を宣言する

import './_ajaxUpdate.js'
import './_top.js'
import './_form.js'
import './_user.js'
import './_api.js'
import './_toast.js'
import './_countChip.js'
import './_message.js'
import './_slide.js'
import './_messageCheck.js'
import './_mypageEntry.js'
import './_errorLog.js'
import './_ajax.js'

//  ###    ###   #####   ####      ###    ##
//  ## #  # ##  ##   ##  ##  ##   ## ##   ##
//  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
//  ##      ##  ##   ##  ##  ##  #######  ##
//  ##      ##   #####   ####    ##   ##  ######

const modals = document.getElementsByClassName('js-modal') // モーダル本体
if (modals[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-open')) {
      return
    }
    const target = e.target.closest('.js-modal-open').dataset.modal
    e.preventDefault()
    if (
      target !== 'mail-send' &&
      target !== 'mail-cancel' &&
      target !== 'mail-cancelResponse' &&
      target !== 'mail-selectCancel' &&
      target !== 'mail-userClear'
    ) {
      modalClose()
    }
    const openModals = document.querySelectorAll('.js-modal--' + target)
    for (const openModal of openModals) {
      openModal.classList.add('active')
    }

    scrollLock('body', '.js-modal')
  })
  // モーダル撤去
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    e.preventDefault()
    modalClose()
    scrollLock('body', '.js-modal')
  })
}

function modalClose() {
  // モーダルを消す
  for (let index = 0; index < modals.length; index++) {
    const modal = modals[index]
    modal.classList.remove('active')
  }
}

/*
########  ####    ###    ##        #######   ######
##     ##  ##   ##   ##  ##       ##     ## ##
##     ##  ##  ##     ## ##       ##     ## ##   ####
##     ##  ##  ######### ##       ##     ## ##    ##
########  #### ##     ## ########  #######   ######

<div id="js-dialog" class="modal modal--dialog">
    <div class="modal__frame modal__frame--dialog">
        <div class="modal__box modal__box--dialog dialog">
            <div id="js-dialog-text" class="dialog__text">
                よろしいですか？
            </div>
            <div class="dialog__list flex bet break">
                <button type="button" class="js-dialog-no js-dialog-close dialog__btn md-btn blueLine">
                    キャンセル
                </button>
                <button type="button" class="js-dialog-yes js-dialog-close dialog__btn md-btn graBlue">
                    OK
                </button>
            </div>
        </div>
    </div>
</div>

window.dialogOpen('○○をクリアします', 'OK', 'キャンセル', 'js-dialogAgree', dialogData)
window.addEventListener('click', function (e) {
  // 指定のIDを持つ
  if (e.target.id === 'js-dialogAgree') {
    carClear(e.target.dataset.dialog)
  }
})
*/
const dialogOverlay = document.getElementById('dialogOverlay') // ダイアログ用オーバーレイ
const dialog = document.getElementById('js-dialog') // ダイアログ
let dialogYesBtnColor = 'graBlue'
window.dialogOpen = function (text, yesText = 'OK', noText = 'キャンセル', yesId, yesData, yesBtn = 'graBlue') {
  // ダイアログモーダルを開く
  dialog.classList.add('active')
  scrollLock('body', '#js-dialog')

  // 文言を決める
  const dialogText = document.getElementById('js-dialog-text')
  const dialogYes = document.querySelector('.js-dialog-yes')
  const dialogNo = document.querySelector('.js-dialog-no')
  dialogText.innerHTML = text
  dialogYes.innerText = yesText
  dialogYes.id = yesId
  dialogYes.dataset.dialog = yesData
  dialogNo.innerText = noText
  dialogNo.focus()

  // ボタン色を決める
  dialogYes.classList.remove(dialogYesBtnColor)
  dialogYes.classList.add(yesBtn)
  dialogYesBtnColor = yesBtn
}

// ダイアログ撤去
window.addEventListener('click', (e) => {
  if (!e.target.closest('.js-dialog-close')) {
    return
  }
  e.preventDefault()
  dialog.classList.remove('active')
  scrollLock('body', '#js-dialog')
})

//
//  ##       #####    ####    ##  ##     ##
//  ##      ##   ##  ##       ##  ####   ##
//  ##      ##   ##  ##  ###  ##  ##  ## ##
//  ##      ##   ##  ##   ##  ##  ##    ###
//  ######   #####    ####    ##  ##     ##
//
let viewicon = document.getElementById('js-password-view')
let inputtype = document.getElementById('password')
$('#js-password-view').on('click', function () {
  if (inputtype.type === 'password') {
    inputtype.type = 'text'
    viewicon.innerHTML = '<i class="eye icon-eye"></i>'
  } else {
    inputtype.type = 'password'
    viewicon.innerHTML = '<i class="icon icon-eye-close"></i>'
  }
})

/*
  ######          ########  #######   ######    ######   ##       ########
 ##                  ##    ##     ## ##        ##        ##       ##
 ##       #######    ##    ##     ## ##   #### ##   #### ##       ######
 ##                  ##    ##     ## ##    ##  ##    ##  ##       ##
  ######             ##     #######   ######    ######   ######## ########

// クリックされたとき、属するグループのクラスを反転させる
<button type="button" class="js-clickToggle" data-toggle-group="hogeGroup"></button>
<div class="js-clickToggle--hogeGroup"></div>

*/
if (document.getElementsByClassName('js-clickToggle')[0]) {
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-clickToggle')) {
      return
    }
    const group = e.target.dataset.toggleGroup
    toggleGroup(group, 'active')
  })
}

function toggleGroup(group, className = 'active') {
  const hide = document.getElementsByClassName('js-clickToggle--' + group)
  for (let index = 0; index < hide.length; index++) {
    hide[index].classList.toggle(className)
  }
}

/*
  ######          ######## ##     ##  ######  ##
 ##               ##         ## ##   ##       ##
 ##       ####### ######      ###    ##       ##
 ##               ##         ## ##   ##       ##
  ######          ######## ##     ##  ######  ########

// クリックされたとき、属するグループのクラスを非アクティブにし、指定ターゲットだけアクティブにする
<button type="button" class="js-clickExclActive" data-excl-group="hogeGroup" data-excl-target="fugaTarget"></button>
<div class="js-clickExclActive-group--hogeGroup js-clickExclActive-target--fugaTarget"></div>

*/
if (document.getElementsByClassName('js-clickExclActive')[0]) {
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-clickExclActive')) {
      return
    }
    const group = e.target.dataset.exclGroup
    const target = e.target.dataset.exclTarget
    exclActive(group, target, 'active')
  })
}
function exclActive(group, target, className = 'active') {
  const hide = document.getElementsByClassName('js-clickExclActive-group--' + group)
  for (let index = 0; index < hide.length; index++) {
    hide[index].classList.remove(className)
  }
  const view = document.getElementsByClassName('js-clickExclActive-target--' + target)
  for (let index = 0; index < view.length; index++) {
    view[index].classList.add(className)
  }
}

//   ####  #####  ##      #####   ####  ######                ##  ##   ##  ###    ###  #####
//  ##     ##     ##      ##     ##       ##                  ##  ##   ##  ## #  # ##  ##  ##
//   ###   #####  ##      #####  ##       ##    ########      ##  ##   ##  ##  ##  ##  #####
//     ##  ##     ##      ##     ##       ##              ##  ##  ##   ##  ##      ##  ##
//  ####   #####  ######  #####   ####    ##               ####    #####   ##      ##  ##
/*
<select name="" class="js-selectJump">
    <option value="" data-link=""></option>
</select>
*/

window.addEventListener('change', function (e) {
  const item = e.target.closest('.js-selectJump')
  if (!item) {
    return
  }
  const link = item.querySelector('option:checked').dataset.link
  if (link) {
    window.location.href = link
  }
})
